import { extendTheme } from "@chakra-ui/react";


const theme = extendTheme({
  fonts: {
    body: "Montserrat, sans-serif",
    heading: "Montserrat, sans-serif",
  },
});

export default theme;
